import { useRef, useCallback } from 'react';

export function useRepairFocus() {
  const previousFocusRef = useRef<HTMLElement | null>(null);

  const save = useCallback(() => {
    previousFocusRef.current = document.activeElement as HTMLElement;
  }, []);

  const repair = useCallback(() => {
    if (previousFocusRef.current && typeof previousFocusRef.current.focus === 'function') {
      previousFocusRef.current?.focus();
    }
  }, []);

  const handleOpenChange = useCallback(
    (details: { open: boolean }) => {
      if (details.open) {
        save();
      } else {
        repair();
      }
    },
    [repair, save]
  );

  return {
    save,
    repair,
    handleOpenChange,
  };
}
